<template>
  <div class="custom-text">
    <vs-row class="mb-5">
      <vs-col vs-xs="12" vs-sm="8" vs-lg="8">
        <table>
          <tr>
            <td class="font-medium">{{ $t('provider') | capitalize }}:</td>
            <td>{{ data.vendor_name || '' }}</td>
          </tr>
          <tr>
            <td class="font-medium">{{ $t('carrier') | capitalize }}:</td>
            <td>{{ data.transporter_name || '' }}</td>
          </tr>
          <tr>
            <td class="font-medium">{{ $t('client') | capitalize }}:</td>
            <td>{{ data.client_name || '' }}</td>
          </tr>
          <tr>
            <td class="font-medium">{{ $t('tracking') | capitalize }}:</td>
            <td>{{ data.tracking_number || '' }}</td>
          </tr>
          <tr>
            <td class="font-medium">{{ $t('destination') | capitalize }}:</td>
            <td>{{ data.destination || '' }}</td>
          </tr>
          <tr>
            <td class="font-medium">{{ $tc('po_number') | capitalize }}:</td>
            <td>{{ data.PO_number || '' }}</td>
          </tr>
          <tr>
            <td class="font-medium">{{ $t('damaged') | capitalize }}:</td>
            <td>{{ data.is_damage == '0' ? 'no' : 'si' }}</td>
          </tr>
        </table>
        <p class="font-medium">{{ $t('comments') | capitalize }}:</p>
        <p>{{ data.comments || '' }}</p>
      </vs-col>
      <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
        <vs-row class="mb-4">
          <vs-col>
            <entry-status
              :status="data.status_name"
              :background="data.status_color"
              :date="data.updated_at"
              :icon="data.icon_vue"
            />
          </vs-col>
        </vs-row>
        <vs-row class="mb-4">
          <vs-col>
            <vs-chip color="primary" v-if="data.flammable === '1'">{{ $t('flammable') | capitalize }}</vs-chip>
            <vs-chip color="warning" v-if="data.complete !== '1' "> {{ $t('incomplete') | capitalize }} </vs-chip>
            <vs-chip color="#44cad4" v-if="data.in_inventary == 1">{{ $t('in_inventary') }} </vs-chip>
            <vs-chip :color="data.pallet === '1' ? 'success':'danger'" >{{ data.pallet === '1' ? 'HT Pallet': 'Non-HT Pallet' }}</vs-chip>
          </vs-col>
        </vs-row>
  
        <vs-row class="mb-4">
          <vs-col>
            <table>
              <tr>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td class="font-medium">
                  {{ $t('created_by') | capitalize }}:
                </td>
                <td>{{ data.created_by_name }}</td>
              </tr>
              <tr>
                <td class="font-medium">{{ $t('warehouse') | capitalize }}:</td>
                <td>{{ data.warehouse_name }}</td>
              </tr>
            </table>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import EntryStatus from './EntryStatus.vue'

export default {
  components: {
    EntryStatus,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

